document.addEventListener('DOMContentLoaded', function () {
    // Function to pause all videos
    function pauseAllCommunityVideos() {
        const videos = document.querySelectorAll('.anni5-community .video_box');
        videos.forEach(video => {
            try {
                video.pause();
            } catch (e) {}
        });
    }

    // Initialize Swiper for the main community carousel
    // This is handled by custom-swiper.js usually, but we need to hook into it
    // If custom-swiper is used, we might need to find the swiper instance
    
    // For the Product Dialog Swiper
    const communityDialogSwiper = new Swiper('.anni5-community .swiper_product', {
        slidesPerView: 1,
        spaceBetween: 20,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.anni5-community .button_next',
            prevEl: '.anni5-community .button_prev',
        },
        observer: true,
        observeParents: true,
        on: {
            slideChangeTransitionEnd: function () {
                pauseAllCommunityVideos();
                try {
                    const activeVideo = document.querySelector(`.anni5-community #video-${this.activeIndex + 1}`);
                    if (activeVideo) activeVideo.play();
                } catch (e) {}
            },
        },
    });

    // Image click to open dialog
    $(document).on('click', '.anni5-community .community-card', function() {
        const index = $(this).closest('.swiper-slide').index();
        const $section = $(this).closest('.anni5-community');
        
        communityDialogSwiper.slideTo(index, 0);
        $section.find('.product_dialog').fadeIn(300);
        
        // Prevent body scroll
        $('body').addClass('overflow-hidden');
        
        try {
            const video = document.querySelector(`.anni5-community #video-${index + 1}`);
            if (video) video.play();
        } catch (e) {}
    });

    // Close dialog
    $(document).on('click', '.anni5-community .close_dialog', function() {
        pauseAllCommunityVideos();
        $(this).closest('.product_dialog').fadeOut(300);
        $('body').removeClass('overflow-hidden');
    });

    // Close on outside click
    $(document).on('click', '.anni5-community .product_dialog', function(e) {
        if ($(e.target).hasClass('product_dialog')) {
            pauseAllCommunityVideos();
            $(this).fadeOut(300);
            $('body').removeClass('overflow-hidden');
        }
    });
});
